import {
  GTM_GENERIC_EVENT,
  GTM_USER_EVENT,
  GTM_USER_EVENT_CART,
  GTM_USER_EVENT_TELL_US_MORE,
  GTM_USER_EVENT_DEFAULT_DATE,
  GTM_USER_EVENT_ADD_PACKAGE,
  GTM_IS_IDK,
  GTM_USER_EVENT_MILEAGE_ENTERED,
  GTM_USER_EVENT_SIGN_ENTERED,
  GTM_USER_EVENT_NOTES_ENTERED,
  GTM_USER_EVENT_SIGNATURE_FULL_SCREEN,
  GTM_USER_EVENT_OPEN_DISCLAIMER_MODAL,
  GTM_USER_SIDEBAR_BUTTON,
  GTM_SET_DIMENSION_CONFIRMATION_KEY,
  GTM_SET_DIMENSION
} from './actionTypes';

// Actions
import { setStartEventSent } from 'store/reducers/userInteractions/actions';
import {
  gaClickTrackingEvent,
  gaAsburyEvents
} from 'store/reducers/ga/actions';
import {
  clickTrackingEvent,
  triggerShiftEvent
} from 'store/reducers/clickTracking/actions';

// Selectors
import { wasStartEventSent } from 'store/reducers/userInteractions/selectors';
import { getShiftServiceStartObj } from 'store/reducers/clickTracking/selectors';
import { getExternalValetProvider } from 'store/reducers/dealerSettings/selectors';

// Constants
import { GA_EVENTS } from 'constants/ga';
import { CLICKTRACKING_TRIGGERS } from 'constants/clickTracking';
import { GTM_STATUS_TRACKER_EVENTS } from 'constants/statusTracker';
import { GTM_RECAPTCHA_EVENTS } from 'constants/recaptcha';
import { TRANSPORTATION } from 'constants/transportation';
const { VALET, VALETLOANER } = TRANSPORTATION;

export function gtmUserEvent(
  eventElement,
  eventAction,
  eventResult,
  eventLocation,
  eventValue
) {
  return {
    type: GTM_USER_EVENT,
    payload: {
      eventElement,
      eventAction,
      eventResult,
      eventLocation,
      eventValue
    }
  };
}

export function gtmGenericEvent(
  eventCategory,
  eventAction,
  eventLabel,
  eventValue
) {
  return {
    type: GTM_GENERIC_EVENT,
    payload: {
      eventCategory,
      eventAction,
      eventLabel,
      eventValue
    }
  };
}

export const gtmThirdPartyValetConvertionEvent = transportationOption => (
  dispatch,
  getState
) => {
  const externalValetProvider = getExternalValetProvider(getState());
  if (
    (transportationOption === VALET || transportationOption === VALETLOANER) &&
    Boolean(externalValetProvider)
  ) {
    dispatch(
      gtmGenericEvent(
        'Appointment Conversion With Third Party Valet',
        `Third Party Valet Conversion With ${externalValetProvider}`,
        'Create Appointment With Third Party Valet'
      )
    );
  }
};

export const gtmStartGenericEvent = () => (dispatch, getState) => {
  if (!wasStartEventSent(getState())) {
    dispatch(
      gtmGenericEvent('Starts', 'Interaction With App', 'Session Start', null)
    );
    dispatch(setStartEventSent(true));
    // @GA EVENT START
    dispatch(gaClickTrackingEvent(GA_EVENTS.START));
    dispatch(clickTrackingEvent(CLICKTRACKING_TRIGGERS.START));
    // @Shift EVENT START
    dispatch(triggerShiftEvent(getShiftServiceStartObj(getState())));
  }
};

export function gtmUserEventSidebarButton() {
  return {
    type: GTM_USER_SIDEBAR_BUTTON,
    payload: {
      eventElement: 'Settings Menu Button',
      eventAction: 'Clicked',
      eventResult: 'Settings Menu Opened'
    }
  };
}

export function gtmUserEventShoppingCart() {
  return {
    type: GTM_USER_EVENT_CART,
    payload: {
      eventElement: 'Shopping Cart Button',
      eventAction: 'Clicked',
      eventResult: 'Shopping Cart selected'
    }
  };
}

export function gtmUserEventDefaultDateSelected() {
  return {
    type: GTM_USER_EVENT_DEFAULT_DATE,
    payload: {
      eventElement: 'Calendar Default Date Button',
      eventAction: 'Selected',
      eventResult: 'Default Date Selected',
      eventLocation: 'GTM_CURRENT_PAGE > Calendar Section'
    }
  };
}

export function gtmUserEventTellUsMoreSelected() {
  return {
    type: GTM_USER_EVENT_TELL_US_MORE,
    payload: {
      eventElement: 'Tell Us More TextBox',
      eventAction: 'Filled',
      eventResult: 'Other Service Added',
      eventLocation: `GTM_CURRENT_PAGE > Don't see what you're looking for?`
    }
  };
}

export const gtmStatusTrackerEvent = (
  reservationId,
  confirmationKey,
  event
) => (dispatch, getState) => {
  dispatch(gtmSetDimension({ reservationId }));
  switch (event) {
    case GTM_STATUS_TRACKER_EVENTS.START: {
      dispatch(
        gtmGenericEvent('Starts', 'Interaction With App', 'Session Start', null)
      );
      dispatch(
        gaAsburyEvents('Start', 'Service Tracker Started', confirmationKey)
      );
      break;
    }
    case GTM_STATUS_TRACKER_EVENTS.ERROR: {
      dispatch(
        gtmGenericEvent('Error', 'Error Loading', 'Error Loading Details', null)
      );
      break;
    }
    case GTM_STATUS_TRACKER_EVENTS.DISABLED: {
      dispatch(
        gtmGenericEvent(
          'Disabled',
          'Error Loading',
          'Micro site Disabled for Dealer',
          null
        )
      );
      dispatch(gaAsburyEvents('Disabled', 'Displaying Error Page', null));
      break;
    }
    default:
      break;
  }
  dispatch(gtmSetDimension({ reservationId: undefined }));
};

export const gtmRecaptchaEvent = (event, api, token, apiCallSuccess) => (
  dispatch,
  getState
) => {
  const eventCategory = `ReCaptcha - ${api}`;
  switch (event) {
    case GTM_RECAPTCHA_EVENTS.HUMAN_NO_CAPTCHA_NEEDED: {
      dispatch(
        gtmGenericEvent(
          eventCategory,
          'No Captcha',
          `Human Detected - ${token}`,
          null
        )
      );
      break;
    }
    case GTM_RECAPTCHA_EVENTS.HUMAN_CAPTCHA_SUCCESS: {
      dispatch(
        gtmGenericEvent(
          eventCategory,
          'Pass',
          `Human Detected - ${token}`,
          null
        )
      );
      break;
    }
    case GTM_RECAPTCHA_EVENTS.OPEN_MODAL: {
      dispatch(
        gtmGenericEvent(eventCategory, 'Open Captcha Modal', `Open Modal`, null)
      );
      break;
    }
    case GTM_RECAPTCHA_EVENTS.CAPTCHA_FAILED: {
      dispatch(gtmGenericEvent(eventCategory, 'Fail', `Captcha Failed`, null));
      break;
    }
    case GTM_RECAPTCHA_EVENTS.CLOSE_MODAL: {
      dispatch(
        gtmGenericEvent(
          eventCategory,
          'Close Captcha Modal',
          `Close Modal`,
          null
        )
      );
      break;
    }
    case GTM_RECAPTCHA_EVENTS.API_CALL: {
      dispatch(
        gtmGenericEvent(
          eventCategory,
          apiCallSuccess + '',
          `${api} called - ${token}`,
          null
        )
      );
      break;
    }
    case GTM_RECAPTCHA_EVENTS.RECAPTCHA_ERROR: {
      dispatch(
        gtmGenericEvent(
          eventCategory,
          'Recaptcha Error',
          'Recaptcha Error in onError Callback',
          null
        )
      );
      break;
    }
    default:
      break;
  }
};

export function gtmUserEventPackageAdded(packageSelected) {
  return {
    type: GTM_USER_EVENT_ADD_PACKAGE,
    payload: packageSelected.menuType.name
  };
}

export function gtmUserEventMileageEntered() {
  return {
    type: GTM_USER_EVENT_MILEAGE_ENTERED,
    payload: '1'
  };
}

export function gtmUserEventLicensePlateEntered() {
  return {
    type: GTM_USER_EVENT,
    payload: {
      eventElement: 'License Plate Input',
      eventAction: 'Filled',
      eventResult: 'License Plate Filled',
      eventLocation: `GTM_CURRENT_PAGE > License Plate Section`
    }
  };
}

export function gtmUserEventColorEntered() {
  return {
    type: GTM_USER_EVENT,
    payload: {
      eventElement: 'Color Options',
      eventAction: 'Filled',
      eventResult: 'Color Filled',
      eventLocation: `GTM_CURRENT_PAGE > Color Section`
    }
  };
}

export function gtmUserEventSignEntered() {
  return {
    type: GTM_USER_EVENT_SIGN_ENTERED,
    payload: '1'
  };
}

export function gtmUserEventNotesEntered() {
  return {
    type: GTM_USER_EVENT_NOTES_ENTERED,
    payload: '1'
  };
}

export function gtmUserEventSignatureFullScreen() {
  return {
    type: GTM_USER_EVENT_SIGNATURE_FULL_SCREEN,
    payload: '1'
  };
}

export function gtmUserEventOpenDisclaimerModal() {
  return {
    type: GTM_USER_EVENT_OPEN_DISCLAIMER_MODAL,
    payload: '1'
  };
}

export function gtmIsIDK(button) {
  return {
    type: GTM_IS_IDK,
    payload: button
  };
}

export function gtmSetDimensionConfirmationKey(confirmationKey) {
  return {
    type: GTM_SET_DIMENSION_CONFIRMATION_KEY,
    payload: confirmationKey
  };
}

export function gtmSetDimension(dimension) {
  return {
    type: GTM_SET_DIMENSION,
    payload: dimension
  };
}

export function gtmContactPreferenceMethod(selectedOption) {
  return {
    type: GTM_USER_EVENT,
    payload: {
      eventElement: 'Contact Preference Combo',
      eventAction: 'Selected',
      eventResult: selectedOption + ' option selected',
      eventLocation: `GTM_CURRENT_PAGE > Contact preference`
    }
  };
}

export function gtmContactPreferenceNumberChange(number) {
  return {
    type: GTM_USER_EVENT,
    payload: {
      eventElement: 'Contact Preference Text Input',
      eventAction: 'Changed',
      eventResult: 'Default number changed',
      eventLocation: `GTM_CURRENT_PAGE > Contact preference`
    }
  };
}

export function gtmNoAdvisorOptions(selectedOption) {
  return {
    type: GTM_USER_EVENT,
    payload: {
      eventElement: selectedOption + ' button',
      eventAction: 'Selected',
      eventResult: selectedOption + ' option selected',
      eventLocation: `GTM_CURRENT_PAGE > Do you need to speak with a service advisor today?`
    }
  };
}

export function gtmStartCheckInClick() {
  return {
    type: GTM_USER_EVENT,
    payload: {
      eventElement: 'Start check in button',
      eventAction: 'Clicked',
      eventResult: 'Start check in button clicked',
      eventLocation: `GTM_CURRENT_PAGE > Start Check In`
    }
  };
}

export function gtmCompleteCheckInClick() {
  return {
    type: GTM_USER_EVENT,
    payload: {
      eventElement: 'Complete check in button',
      eventAction: 'Clicked',
      eventResult: 'Complete check in button clicked',
      eventLocation: `GTM_CURRENT_PAGE > Complete Check In`
    }
  };
}



// WEBPACK FOOTER //
// ./src/store/reducers/gtm/actions.js